import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/security_1.png'
import _imports_1 from '@/assets/img/check.svg'


const _hoisted_1 = { class: "mainInfo" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "titleContainer" }
const _hoisted_5 = {
  class: "sectionTitle md font-prompt",
  style: {"font-size":"38px"}
}
const _hoisted_6 = { class: "contentContainer" }
const _hoisted_7 = { class: "infoBlock" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "textBlock lg" }
const _hoisted_10 = { style: {"font-size":"18px"} }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "textBlock lg" }
const _hoisted_13 = { class: "title font-prompt" }
const _hoisted_14 = { style: {"font-size":"18px"} }
const _hoisted_15 = { class: "securityList" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "secutity"
}, null, -1)
const _hoisted_17 = {
  href: "/static/business_license.pdf",
  target: "_blank"
}
const _hoisted_18 = {
  href: "/static/ISO_CERTIFICATE__ISO_27001-2013__2022.pdf",
  target: "_blank"
}
const _hoisted_19 = { class: "apiImg animatedBlock runningAnimation" }
const _hoisted_20 = { class: "circleWrap" }
const _hoisted_21 = { class: "circle animated" }
const _hoisted_22 = {
  class: "text animated",
  style: {"font-size":"30px"}
}
const _hoisted_23 = { class: "circle animated" }
const _hoisted_24 = {
  class: "text animated",
  style: {"font-size":"30px"}
}
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "overlay animated" }, null, -1)
const _hoisted_26 = {
  class: "text animated",
  style: {"font-size":"30px"}
}
const _hoisted_27 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "check",
  class: "icon animated"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.t("mainInfo.title")), 1)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("p", _hoisted_10, _toDisplayString(_ctx.t("mainInfo.content.item1.value")), 1)
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("span", _hoisted_13, _toDisplayString(_ctx.t("mainInfo.content.item2.label")), 1),
                _createVNode("p", _hoisted_14, _toDisplayString(_ctx.t("mainInfo.content.item2.value")), 1)
              ])
            ])
          ]),
          _createVNode("ul", _hoisted_15, [
            _createVNode("li", null, [
              _hoisted_16,
              _createVNode("span", null, _toDisplayString(_ctx.t("mainInfo.security1")), 1)
            ]),
            _createVNode("li", null, [
              _createVNode("a", _hoisted_17, [
                _createVNode("span", null, _toDisplayString(_ctx.t("mainInfo.security2")), 1)
              ])
            ]),
            _createVNode("li", null, [
              _createVNode("a", _hoisted_18, [
                _createVNode("span", null, _toDisplayString(_ctx.t("mainInfo.security3")), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_19, [
      _createVNode("div", _hoisted_20, [
        _createVNode("div", _hoisted_21, [
          _createVNode("span", _hoisted_22, _toDisplayString(_ctx.t("mainInfo.animation.website")), 1)
        ]),
        _createVNode("div", _hoisted_23, [
          _createVNode("span", _hoisted_24, _toDisplayString(_ctx.t("mainInfo.animation.payment")), 1)
        ])
      ]),
      _hoisted_25,
      _createVNode("span", _hoisted_26, _toDisplayString(_ctx.t("mainInfo.animation.api")), 1),
      _hoisted_27
    ])
  ]))
}